import React from 'react';
import { Users, Group } from 'lucide-react';

const TabSelector = ({ activeTab, setActiveTab }) => {
  return (
    <div className="mb-6">
      <div className="border-b border-gray-200">
        <nav className="-mb-px flex gap-4 sm:gap-8 overflow-x-auto whitespace-nowrap pb-1">
          <button
            onClick={() => setActiveTab('customers')}
            className={`py-4 px-1 border-b-2 font-medium text-sm shrink-0 ${
              activeTab === 'customers'
                ? 'border-primary text-primary'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
            }`}
          >
            <div className="flex items-center">
              <Users className="w-5 h-5 mr-2" />
              Customers
            </div>
          </button>
          <button
            onClick={() => setActiveTab('groups')}
            className={`py-4 px-1 border-b-2 font-medium text-sm shrink-0 ${
              activeTab === 'groups'
                ? 'border-primary text-primary'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
            }`}
          >
            <div className="flex items-center">
              <Group className="w-5 h-5 mr-2" />
              Pools
            </div>
          </button>
        </nav>
      </div>
    </div>
  );
};

export default TabSelector;